import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormControl,
  Validators
} from "@angular/forms";
import { Observable, of } from "rxjs";
import { debounceTime, map, switchMap, tap } from "rxjs/operators";
import { LoadingDrivebService } from "@shared/components/loading-driveb/loading-driveb.service";
import { PartCategorySimplifiedDTO } from "@shared/models/part-category-dto";
import { PartCategoryService } from "@core/services/part-category.service";
import { MatOptionSelectionChange } from "@angular/material/core";

@Component({
    selector: "app-smartfleet-part-category-auto-complete",
    templateUrl: "./part-category-auto-complete.component.html",
    styleUrls: ["./part-category-auto-complete.component.scss"],
    standalone: false
})
export class PartCategoryAutoCompleteComponent implements OnInit {
  loading = false;
  partCategory = new UntypedFormControl();
  searchForm = this.fb.group({
    name: this.partCategory
  });

  // partCategory$: Observable<PartCategorySimplifiedDTO[]>;
  partCategories: PartCategorySimplifiedDTO[];

  @Input() set required(value: boolean) {
    if (value && !this.disabled) {
      this.searchForm.controls.name.setValidators([Validators.required]);
    } else {
      this.searchForm.controls.name.clearValidators();
    }
    this.searchForm.updateValueAndValidity();
  }
  @Input() set disabled(value: boolean) {
    if (value) {
      this.searchForm.disable();
    } else {
      this.searchForm.enable();
    }
  }

  @Input() set value(value: string) {
    if (value) {
      this.searchForm.get("name").setValue(value);
    }
  }

  @Output() onChange: any = new EventEmitter<PartCategorySimplifiedDTO>();

  constructor(
    private fb: UntypedFormBuilder,
    private partCategoryService: PartCategoryService,
    private loadingDrivebService: LoadingDrivebService
  ) {}

  ngOnInit(): void {
    this.partCategory.valueChanges
      .pipe(
        debounceTime(200),
        tap(
          () => (
            (this.loading = true), this.loadingDrivebService.setAutoMode(false)
          )
        ),
        switchMap((value: string) => {
          if (value) {
            return this.partCategoryService.findByFilters(value);
          } else {
            this.loadingDrivebService.setAutoMode(true);
            this.onChange.emit({} as PartCategorySimplifiedDTO);
            return of([]) as Observable<PartCategorySimplifiedDTO[]>;
          }
        })
        // map((result) => {
        //   this.loadingDrivebService.setAutoMode(true);
        //   this.loading = false;
        //   return result;
        // })
      )
      .subscribe(
        (data: any) => {
          this.partCategories = data.content;
          this.loadingDrivebService.setAutoMode(true);
          this.loading = false;
        },
        (error) => {
          this.partCategories = [];
          this.loadingDrivebService.setAutoMode(true);
          this.loading = false;
        }
      );
  }

  handlePartCategoryChange(
    event: MatOptionSelectionChange,
    partCategory: PartCategorySimplifiedDTO
  ) {
    if (event.isUserInput) this.onChange.emit(partCategory);
  }

  clean() {
    this.searchForm.reset();
  }
}
